module.exports = __webpack_public_path__ + "img/03.3872f8d3.jpg";